import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {CLINICAL_STUDIES_VALIDATION_CONSTANTS} from 'studies/StudyConstants';

import ClinicalStudyDesignTabContents from '../clinical/ClinicalStudyDesignTabContents';
import ClinicalStudyExecutionOverview from '../clinical/ClinicalStudyExecutionOverview';
import ClinicalStudyOverviewTabContents from '../clinical/ClinicalStudyOverviewTabContents';
import {PreclinicalStudyState, StudySchema, TypedStudyAdapter} from '../utils/TypedStudyTypes';

export const PreclinicalStudyAdapter: TypedStudyAdapter<never, PreclinicalStudyState> = {
  type: StudyType.PRECLINICAL,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: false,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: false,

  isVisualizationEnabled: false,

  isOOTBChartingEnabled: false,

  maxRunsPerStudy: () => CLINICAL_STUDIES_VALIDATION_CONSTANTS.MAX_NUM_ASSAY_RUNS_PER_CLINICAL_BASED_STUDY,

  allowReturnToDesignPhase: true,

  allowRequireDesignApproval: BenchlingConfig.STUDIES_ENABLE_REVIEW,

  renderMetadataSection(_state: PreclinicalStudyState) {
    return <></>;
  },

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: PreclinicalStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: PreclinicalStudyState) {
    return {};
  },
  creation: {},
  design: {
    ui: {
      tab: ClinicalStudyDesignTabContents,
    },
  },
  overview: {
    ui: {
      tab: ClinicalStudyOverviewTabContents,
      design: null,
      execution: ClinicalStudyExecutionOverview,
    },
  },
  review: {},
};
